import { axios } from 'lib/axios'
import { endpoints } from 'utils/endpoints'
import { GetIncidentsParams } from './getIncidents'
import { GetThreatDetailParams } from './getIncidentDetails'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { ApiKey } from '../components/enums'

// Get NSightPatch threat listing
export const getNSightPatchThreatLisiting = (params: GetIncidentsParams) => {
  return axios.get(endpoints.getNSightPatchIncidentLisiting, { params })
}

export const UseNSightPatchThreatLisiting = (params: GetIncidentsParams = {}) => {
  return useQuery([ApiKey.NSightPatchLisiting, ApiKey.list, params], () => getNSightPatchThreatLisiting(params))
}

// Get NSightPatch threat details
export const getNSightPatchThreatDetail = async (params: GetThreatDetailParams) => {
  return axios.get(endpoints.NSightPatchThreatDetails, { params })
}

export const useNSightPatchThreatDetail = (params: GetThreatDetailParams) => {
  return useQuery([ApiKey.NSightPatchThreats, ApiKey.detail, params], () => getNSightPatchThreatDetail(params))
}

// Accept or reject a claim for NSightPatch
export const acceptOrRejectClaimNSightPatch = async (data: object) => {
  return axios.post(endpoints.acceptOrRejectClaimNSightPatch, data)
}

export const useAcceptOrRejectClaimNSightPatch = () => {
  const queryClient = useQueryClient()
  return useMutation(acceptOrRejectClaimNSightPatch, {
    onSuccess: () => {
      queryClient.invalidateQueries([ApiKey.NSightPatchLisiting, ApiKey.list])
    },
  })
}
